module.exports = __webpack_public_path__ + "img/help.7f28709b.png";